const Content = {
  'people': {
    'join': {
      'html': `
        <p>
          <strong>Interested in joining our team?</strong>
          <br/>
          <a href="mailto:reception-culvercity@nrgmr.com">Drop us a note</a> or <a href="#careers">see where</a> you can make an impact!
        </p>
      `
    }
  }
};

export { Content };
